import { child, get, ref } from "firebase/database";

import { database } from "../config/firebase";

export interface UserInboxNotification {
  id: string;
  title: string;
  body: string;
  timestamp: number;
  read: boolean;
  type: string;
}

export async function listUserNotifications(
  userId: string
): Promise<UserInboxNotification[]> {
  if (!database || !userId) return [];
  const snap = await get(child(ref(database), `users/${userId}/notifications`));
  if (!snap.exists()) return [];
  const val = snap.val() as Record<string, Record<string, unknown>>;
  return Object.entries(val).map(([id, n]) => ({
    id,
    title: String(n.title ?? ""),
    body: String(n.body ?? ""),
    timestamp: Number(n.timestamp ?? 0),
    read: Boolean(n.read),
    type: String(n.type ?? "info"),
  }));
}
